import createSelector from 'selectorator';

const cweSelectors = {
  getCweList: createSelector(['cwe.cwes'], data => data),
  getLoading: createSelector(['cwe.status.loading'], data => data),
};

export default cweSelectors;
